import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const InvalidFormAlert = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, getLabel('products.contactLens.info.invalidMessage'));
};

export { InvalidFormAlert };
//# sourceMappingURL=InvalidFormAlert.js.map
